import * as yup from "yup";
import { locationFieldsSchema } from "../utils/locationFieldsValidation";

export const existingProviderValidationSchema = yup.object().shape({
  selectedProvider: yup.object().nullable(),
  providerContactDetails: yup.object().nullable(),
  locationType: yup
    .string()
    .oneOf(
      ["primary", "secondary", "other"],
      "You must select a location type."
    )
    .required("This field is required"),
  primaryLocationTextBox: yup.string(),
  secondaryLocationTextBox: yup.string(),
  otheryLocationTextBox: yup.string(),
  secondaryAddress: yup.string().notRequired(),
  // Sync from UI: when user selects "new-location", this is "new-location"
  selectedAssessmentLocationId: yup.string().optional(),
  // Primary location (LocationFields) required only when "new-location" is selected
  ...locationFieldsSchema("primary", {
    mode: "always",
    whenField: "selectedAssessmentLocationId",
    whenIs: "new-location",
  }),
  serviceCategories: yup
    .array()
    .min(1, "Please select at least one service category.")
    .required(),
  draftDate: yup
    .object({
      startDate: yup
        .date()
        .required("Desired Initial Draft Date is required")
        .test(
          "is-valid-date",
          "Start date must be a valid date",
          (value) => !isNaN(new Date(value).getTime())
        ),
    })
    .required("Desired Initial Draft Date is required"),
  additionalDetails: yup.string().notRequired(),
  multiSponsor: yup.boolean().notRequired(),
  providerName: yup.string(),
  mainContactName: yup.string(),
  mainContactEmail: yup.string().email(),
  country: yup.object().nullable(),
  providerUrl: yup.string(),
  streetAddress: yup.string(),
  city: yup.string(),
  state: yup.string(),
  zipCode: yup.string(),
  additionalAddress: yup.string(),
  onsiteRemote: yup
    .object()
    .shape({
      onsite: yup.boolean().required("Onsite is required."),
      remote: yup.boolean().required("Remote is required."),
    })
    .test(
      "only-one-true",
      "Only one option (onsite or remote) must be selected.",
      (value) => {
        const values = Object.values(value || {});
        return values.filter((v) => v === true).length === 1;
      }
    )
    .required("This field is required"),
});
